import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
import AutofillChoiceChip from "@/components/AutofillChoiceChip.vue";
// Catalog rows the autofill run matched to the document's medication. Rendered inside
// AutofillFieldChoices' row next to the free-text choices; applying one sets name, NDC and
// package unit together, the same as picking the row from the medication search.
export default /*@__PURE__*/ _defineComponent({
    __name: 'AutofillMedicationChoices',
    props: {
        matches: {},
        target: {}
    },
    emits: ["apply"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.matches, (match, index) => {
                return (_openBlock(), _createBlock(AutofillChoiceChip, {
                    key: `${index}:${match.nationalDrugCode}`,
                    applied: match.isAppliedTo(props.target),
                    icon: "mdi-database-search-outline",
                    onClick: ($event) => (emit('apply', match))
                }, {
                    tooltip: _withCtx(() => [
                        _cache[0] || (_cache[0] = _createElementVNode("div", null, "From the medication catalog", -1)),
                        (match.strength)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Strength: " + _toDisplayString(match.strength), 1))
                            : _createCommentVNode("", true),
                        (match.routeAdministration)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Route: " + _toDisplayString(match.routeAdministration), 1))
                            : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(match.label) + " ", 1)
                    ]),
                    _: 2
                }, 1032, ["applied", "onClick"]));
            }), 128));
        };
    }
});
